import { Pipe, PipeTransform } from '@angular/core';

import { ManagementBondRequestModel } from '@app/data-layer/models/management';
import { CustomState, enumBondRequestState } from '@app/data-layer/enums/common';
import { BondRequestModel } from '@app/data-layer/models/common';

@Pipe({ name: 'bondRequestState' })
export class BondRequestStatePipe implements PipeTransform {
  public transform(bondRequest: ManagementBondRequestModel | BondRequestModel): string {
    if (bondRequest.state === enumBondRequestState.CUSTOM) {
      return 'BOND_REQUEST_CUSTOM_STATE.' + CustomState[bondRequest.customState.header];
    }

    return 'BOND_REQUEST_STATE.' + enumBondRequestState[bondRequest.state];
  }
}
